// sections: featured-articles (1/2/3) / main-blog / main-blog-post
class ReadingTime extends HTMLElement {
  constructor() {
    super();

    var self = this;
    let wordsPerSecond;
    let totalWords;
    let totalReadingTimeSeconds;
    let readingTimeMinutes;
    let readingTimeSeconds;
    let readingTime;
    let response;
    this.content;

    this.defaults = {
      articleCard: this.getAttribute('data-cards') == "true" ? true : false,
      readingTimeTarget: 'span:first-of-type',
      wordsPerMinute: 270,
      lessThanAMinuteString: Shopify.translation.minute_left
    };

    if(this.defaults.articleCard){
      window.ajaxURL(theme.utils.getParents(self, 'article-card').href).then(function (data) {
        response = new DOMParser().parseFromString(data, 'text/html');
        self.content = response.querySelector(".article-content").innerText;

        //split text by spaces to define total words
        totalWords = self.content.trim().split(/\s+/g).length;
        //define words per second based on words per minute (s.wordsPerMinute)
        wordsPerSecond = self.defaults.wordsPerMinute / 60;
        //define total reading time in seconds
        totalReadingTimeSeconds = totalWords / wordsPerSecond;
        // define reading time
        readingTimeMinutes = Math.floor(totalReadingTimeSeconds / 60);
        // define remaining reading time seconds
        readingTimeSeconds = Math.round(totalReadingTimeSeconds - (readingTimeMinutes * 60));
        // format reading time
        readingTime = `${readingTimeMinutes}:${readingTimeSeconds}`;
  
        // Round time
        if(readingTimeMinutes > 0) {
          // set reading time by the minute
          self.querySelector(self.defaults.readingTimeTarget).innerText = readingTimeMinutes;
          self.querySelector(self.defaults.readingTimeTarget).classList.remove('loading-gradient');
        } else {
          // set reading time as less than a minute
          self.innerHTML = self.defaults.lessThanAMinuteString;
        }
      })
    } else {
      this.content = theme.utils.getParents(this, 'article-container').querySelector(".article-content").innerText;

      //split text by spaces to define total words
      totalWords = this.content.trim().split(/\s+/g).length;
      //define words per second based on words per minute (s.wordsPerMinute)
      wordsPerSecond = this.defaults.wordsPerMinute / 60;
      //define total reading time in seconds
      totalReadingTimeSeconds = totalWords / wordsPerSecond;
      // define reading time
      readingTimeMinutes = Math.floor(totalReadingTimeSeconds / 60);
      // define remaining reading time seconds
      readingTimeSeconds = Math.round(totalReadingTimeSeconds - (readingTimeMinutes * 60));
      // format reading time
      readingTime = `${readingTimeMinutes}:${readingTimeSeconds}`;

      // Round time
      if(readingTimeMinutes > 0) {
        // set reading time by the minute
        this.querySelector(this.defaults.readingTimeTarget).innerText = readingTimeMinutes;
        this.querySelector(this.defaults.readingTimeTarget).classList.remove('loading-gradient');
      } else {
        // set reading time as less than a minute
        this.innerHTML = this.defaults.lessThanAMinuteString;
      }
    }
  }
}
customElements.define('reading-time', ReadingTime);